const host = '/is/'
const hostStore = `${host}store/`

const Api = {
  login: campaignId =>`${host}auth/loginRequest/${campaignId}`,//登录
  campaign: `${hostStore}campaigns`,//活动列表
  campaignInfo: campaignId => `${hostStore}campaign/${campaignId}/info`,//活动详细信息
  userInfo: campaignId => `${hostStore}campaign/${campaignId}/userinfo`,//用户详细信息
  categories: campaignId => `${hostStore}campaign/${campaignId}/categories`,//活动下分类信息
  campaignGoods: campaignId => `${hostStore}campaign/${campaignId}/goods`,//活动所有物品信息
  typeGoods: (typeId) => `${hostStore}type/${typeId}/goods`,//类型下所有商品
  catGoods: catId => `${hostStore}category/${catId}/goods`,//类型下单个cat所有商品
  goodDetail: goodId => `${hostStore}good/${goodId}`, //商品信息
  goodProduct: goodId => `${hostStore}good/${goodId}/products`, //宝贝下不同商品
  goodStock: goodId => `${hostStore}good/${goodId}/stock`, //宝贝下不同商品库存
  goodPic: goodId => `${hostStore}good/${goodId}/pictures`, //宝贝下不同商品图片
  cartNum: campaignId => `${hostStore}cartNum/${campaignId}`, //购物车数量
  cartInfo: campaignId => `${hostStore}cart/${campaignId}`,//获取购物车详情
  updateCart: campaignId => `${hostStore}cart/${campaignId}/modify`,//添加商品 POST
  addCartProduct: campaignId => `${hostStore}cart/${campaignId}/add`,//添加商品 POST
  ordersStats: `${hostStore}order/stats`,//订单状态
  orderList: campaignId => `${hostStore}order/${campaignId}/list`,//所有订单
  orderInfo: orderId => `${hostStore}order/${orderId}/info`,//订单详情
  orderPlace: campaignId => `${hostStore}campaign/${campaignId}/placeOrder`,//下单
  campaignRule: campaignId => `${hostStore}campaign/${campaignId}/rule`,//
  search: campaignId => `${hostStore}campaign/${campaignId}/search`,//搜索
  search2: campaignId => `${hostStore}campaign/${campaignId}/search2`,//搜索
  cancelOrder: orderId => `${hostStore}order/${orderId}/cancel`,
  payment: `${host}p/globalPay/`,
  paymentMb: `${host}p/wechatPay/`,
  auth: `${host}auth/entrance/`,
  jump: `${host}p/agreement/`,
  agreementInfoSubmit:　campaignId =>`${hostStore}agreement/${campaignId}/submit`,//同意用户协议
  agreementInfo:　campaignId =>`${hostStore}agreement/${campaignId}`,//读取用户协议
  checkCampaign:　campaignId =>`${hostStore}campaign/${campaignId}/check`,//检查campaign,
  campaignInfoLogin: campaignId =>`${host}/auth/campaignInfo/${campaignId}`,
  ruleInfo: campaignId =>`${hostStore}campaign/${campaignId}/rule`//使用规则
}
export default Api



// WEBPACK FOOTER //
// ./src/utils/config.js